var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.85231 7.19588C5.09974 7.67423 5.37602 8.12371 5.68118 8.54433C5.99458 8.9732 6.33272 9.37113 6.69561 9.73814C7.0585 10.1052 7.45025 10.4412 7.87087 10.7464C8.28324 11.0515 8.72035 11.3237 9.18221 11.5629L9.24407 11.5876L10.7039 10.1155C10.7946 10.0577 10.9018 10.0186 11.0255 9.99794C11.1492 9.97732 11.2688 10.0454 11.3843 10.2021C11.7554 10.2021 12.1905 10.2247 12.6894 10.2701C13.1884 10.3155 13.5451 10.3381 13.7595 10.3381C13.941 10.3381 14.0977 10.4021 14.2296 10.5299C14.3616 10.6577 14.4276 10.8124 14.4276 10.9938V13.332C14.4276 13.5134 14.3616 13.6701 14.2296 13.8021C14.0977 13.934 13.941 14 13.7595 14C12.1925 14 10.7245 13.7031 9.35541 13.1093C7.97809 12.5155 6.77602 11.7052 5.74922 10.6784C4.72242 9.65155 3.91211 8.45361 3.31829 7.08454C2.73272 5.70722 2.43994 4.23505 2.43994 2.66804C2.43994 2.4866 2.50386 2.3299 2.63169 2.19794C2.75953 2.06598 2.91417 2 3.09561 2H5.43376C5.6152 2 5.7719 2.06598 5.90386 2.19794C6.03582 2.3299 6.1018 2.4866 6.1018 2.66804C6.1018 3.08866 6.13273 3.49691 6.19458 3.89278C6.25644 4.28866 6.34922 4.67629 6.47293 5.05567C6.51417 5.16289 6.52035 5.33608 6.49149 5.57526C6.46262 5.81443 6.40283 5.86392 6.31211 5.72371L4.85231 7.19588Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.151c605e145a929ab37f9c57ae952487.svg";
export { ForwardRef as ReactComponent };